import { retrieveToken } from '../storage';
import { wrapFetch, apiFetch, apiError } from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getProceduraHaccpTramiteId = (id) => {
  const PATH = '/api/paragrafi/procedurehaccp/' + id;
  const URL = BASE_URL + PATH;
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
